// extracted by mini-css-extract-plugin
module.exports = {"cardwrap":"styles_cardwrap__17ZEv","flipped":"styles_flipped__3C9qy"};